export default class Units {
    /**
     * Rounded number to int
     * @param {number} value
     * @param {number} precision
     *
     * @return {string}
     */
    static rounded(value, precision) {
        value = value || 0;

        if (typeof value !== "number") value = parseFloat(value);
        return value.toFixed(precision);
    }

    /**
     * Shorten value to currencly label
     * @param value
     * @param currency
     * @param precision
     * @returns {string}
     */
    static currencyShort(value, currency, precision) {
        let unit = "";

        if (value >= 1000000000) {
            value = Units.rounded(value/1000000000, precision);
            unit ="B";
        } else if (value >= 1000000) {
            value = Units.rounded(value / 1000000, precision);
            unit = "M";
        } else if (value >= 1000) {
            value = Units.rounded(value / 1000, precision);
            unit = "k";
        }

        return currency + value + unit;
    }

    /**
     * Value with limited precisision and unit
     * @param {number} value
     * @param {number} precision
     * @param {string} unit
     * @return {string}
     */
    static unit(value, precision, unit) {
        return Units.rounded(value, precision) + " " + unit;
    }

    /**
     *
     * @param {number} value
     * @return {string}
     */
    static percent(value) {
        return Units.unit(value, 2, "%");
    }
}



// WEBPACK FOOTER //
// ./src/utils/Units.js